import { useState } from "react";
import onClickOutside from "react-onclickoutside";

function Dropdown({
  selectedCamera,
  setSelectedCamera,
  cameraData,
  addCamera
}) {
  const [isActive, setIsActive] = useState(false);

  const handleAddCamera = () => {
    setSelectedCamera(null);
    setSelectedCamera({ name: "", rtsp: "", location: "" });
    setIsActive(false);
  };

  Dropdown.handleClickOutside = () => {
    setIsActive(false);
  };

  let addCameraComp = addCamera &&
    (
      <div onClick={handleAddCamera} className="dropdown-item">
        Add Camera
      </div>
    )

  return (
    <div className="dropdown" >
      <div className="dropdown-btn" onClick={(e) => setIsActive(!isActive)}>
        {selectedCamera && selectedCamera.name || <span className="select-placeholder">Select Camera</span>}
        <span className="fas fa-caret-down"></span>
      </div>
      {isActive && (
        <div className="dropdown-content" style={{zIndex: "10000",
  maxHeight: "210px",   // sirf 5 cameras dikhenge
  overflowY: "auto",    // vertical scroll
  overflowX: "hidden",  // horizontal scroll nahi
   }} >
          {addCameraComp}
          {cameraData?.map((option) => (
            <div
              key={option.camera_number}
              onClick={(e) => {
                setSelectedCamera(option);
                if (addCamera)
                  setSelectedCamera(option);
                setIsActive(false);
              }}
              className="dropdown-item"

            >
              {option.name}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

const clickOutsideConfig = {
  handleClickOutside: () => Dropdown.handleClickOutside,
};

export default onClickOutside(Dropdown, clickOutsideConfig);
